import { useMemo } from "react";
import { Reveal, Overline } from "./Reveal";
import StatusBadge from "./StatusBadge";

export default function Accessories({ products, onOpen }) {
  const items = useMemo(() => products.filter((p) => p.category === "accessory"), [products]);

  return (
    <section id="accessories" data-testid="accessories" className="bg-cream py-24 md:py-36 border-t border-charcoal/15">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <Reveal>
          <Overline>Our Accessories</Overline>
          <h2 className="mt-5 font-display font-black uppercase tracking-normal text-charcoal text-4xl md:text-6xl leading-[0.95]">
            The finishing <span className="text-toga">touch.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-charcoal/15 border border-charcoal/15">
          {items.map((a, i) => (
            <Reveal key={a._id} delay={(i % 3) * 0.1}>
              <button data-testid={`accessory-card-${a._id}`} onClick={() => onOpen(a)} className="group bg-cream text-left w-full h-full">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={a.image} alt={a.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                  <div className="absolute top-4 left-4"><StatusBadge status={a.status} /></div>
                </div>
                <div className="p-6">
                  <span className="text-xs tracking-[0.2em] uppercase font-bold text-toga">{a.subcategory}</span>
                  <h3 className="mt-2 font-display uppercase tracking-tight text-charcoal text-xl font-bold group-hover:text-toga transition-colors">{a.name}</h3>
                </div>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
